"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsUtil = void 0;
/**
 * Determines if the logged in person has a permission for an application. This is
 * not a security guarantee. It's only a convenience.
 * @example
 * PermissionsUtil.hasPermission('merge', { application: 'member-search' });
 */
const hasPermission = ({ applicationName, permission, }) => {
    var _a, _b, _c;
    const currentApplication = getApplicationName(applicationName);
    if ((_b = (_a = pplsi.authZPayload) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.hasOwnProperty(currentApplication)) {
        return (_c = pplsi.authZPayload) === null || _c === void 0 ? void 0 : _c.permissions[currentApplication].includes(permission);
    }
    return false;
};
function getApplicationName(applicationName) {
    return applicationName ? applicationName : window.location.hostname.split('.').slice(0, -2).join('.');
}
exports.PermissionsUtil = {
    hasPermission,
};
//# sourceMappingURL=permissions-util.js.map